import script from "./TariffDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffDescription.vue?vue&type=script&setup=true&lang=js"

import "./TariffDescription.vue?vue&type=style&index=0&id=4ada1fac&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ada1fac"]])

export default __exports__